<template>
<div>
  <div v-show="loaded">
    <div class="b-rotate-img">
      <AppStandardCropper
        @crop="crop"
        ref="appstandardcropper"
        @readyFunctionComplete="handleImageLoaded"
      ></AppStandardCropper>

      <div class="b-rotate-img__result">
        <img v-bind:src="cropImg" />
      </div>
    </div>

    <div class="b-rotate-img__btn--group">
      <button class="b-global__button" @click.prevent="saveImg()">Save</button>
    </div>
  </div>
  <div class="b-rotate-img__loading" v-if="!loaded">Loaing Please wait....</div>
</div>
  
</template>
<script>
import Vue from "vue";
import "cropperjs/dist/cropper.css";

import VueCroppie from "vue-croppie";

import AppStandardCropper from "../AppStandardCropper.vue";

Vue.use(VueCroppie);
export default {
  data() {
    return {
      showCrop: false,
      cropImg:null,
      loaded:false
    };
  },
  mounted() {
    if (this.$store.state.ckycDetails.croppedImgUrl) {
    this.cropImg = this.$store.state.ckycDetails.croppedImgUrl
    this.$nextTick(function() {
        this.$refs.appstandardcropper.updateFile(
        this.$store.state.ckycDetails.croppedImgUrl
        );
    });

    this.showCrop = true;
    } else {
    this.$router.replace({
        name: "ckyc-details-id",
        params: { id: this.$route.params.id }
    });
    }
  },
  components: {
    AppStandardCropper
  },
  methods: {
    crop(croppedCanvas) {
      this.cropImg = croppedCanvas.toDataURL();
      let options = {
        type: "base64",
        format: "jpeg" | "png",
        size: "original",
        quality: 1
      };
      console.log('croppedCanvas',croppedCanvas.toDataURL())
      this.$store.commit("SHOW_NOTIFICATION", {
        showNotification: true,
        message: "Successfully Cropped Image",
        succesFlag: true
      });
    },
    saveImg() {
      this.$store
        .dispatch("uploadImageCkyc", {
          image: this.cropImg,
          id: this.$route.params.id,
          key: this.$route.params.imgname,
          name: `${this.$route.params.imgname}.jpeg`
        })
        .then(res => {
          if (
            this.$route.params.imgname === "url_poa_corr_side1" ||
            this.$route.params.imgname === "url_poa_corr_side2"
          ) {
            this.$store.commit("setcroppedImgUrl", res.data.file_url);
            this.$router.replace({ name: "ckyc-details-mask-img" });
          } else {
            this.$router.back()
            };
        });
    },
    handleImageLoaded(){
      console.log('loaded');
      this.loaded = true
    }
  }
};
</script>
<style scoped>
.b-rotate-img {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  margin-top: 69px;
}
.b-rotate-img__btn--group {
  display: flex;
  justify-content: center;
}
.b-rotate-img__result {
  width: 358px;
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  border: solid 1px #e0e0e0;
  margin-bottom: 25px;
}
.b-rotate-img__result img {
  width: 100%;
}

.croppie-container {
  width: unset;
  height: unset;
}
.b-rotate-img__degree {
  display: flex;
  flex-direction: column;
}
.b-rotate-input {
  margin: 44px;
}
.b-rotate-img__loading{
  margin-top: 74px;
  text-align: center;
}
</style>
